export const REPORT_ACTIONS = {
  SET_LOADING: "SET_LOADING",
  TOGGLE_REPORT_POPUP: "TOGGLE_REPORT_POPUP",
};
